import React from 'react';
/* eslint-disable react-hooks/exhaustive-deps */
import {
  FormikNumberInput as Input,
  UserMeasurementHeightUnitType,
} from '@front-activerse/common-components';
import { useFormikContext } from 'formik';
import { useEffect } from 'react';
import { Col, FormFeedback, FormText, Row } from 'reactstrap';
import { useTranslator } from '@front-activerse/common-components';
import { dietSettings } from '../types';

const convertInchesToFeetsAndInches = (value: number) => {
  const feets = Math.floor(value / 12);
  const inches = Math.floor(value - feets * 12);

  return { feets, inches };
};

const convertFeetsAndInchesToInches = (feets: number, inches: number) => {
  const totalInches = feets * 12 + inches;
  return totalInches;
};

export const Height: React.FC = () => {
  const { t } = useTranslator();
  const { values, setFieldValue, errors, setFieldTouched, touched } =
    useFormikContext<dietSettings>();

  const heightUnit = values.heightUnit;

  useEffect(() => {
    if (heightUnit === UserMeasurementHeightUnitType.in) {
      const feetsAndInches = convertInchesToFeetsAndInches(values.heightValue || 0);

      setFieldValue('heightFt', feetsAndInches.feets);
      setFieldValue('heightIn', feetsAndInches.inches);
    }
  }, []);

  useEffect(() => {
    if (heightUnit === UserMeasurementHeightUnitType.in) {
      setFieldValue(
        'heightValue',
        convertFeetsAndInchesToInches(
          values.heightFt ? values.heightFt : 0,
          values.heightIn ? values.heightIn : 0
        )
      );
    }
  }, [values.heightFt, values.heightIn]);

  return (
    <>
      <h2 className="mb-4 title-large semi-bold">{t('app.biometric.height.headline')}</h2>

      {heightUnit === UserMeasurementHeightUnitType.cm ? (
        <Input
          name="heightValue"
          placeholder="0"
          label=""
          text={t('biometric.height.description', { min: '101 cm', max: '249cm' })}
          unit={heightUnit}
          step="1"
          translateErrMsg={false}
        />
      ) : (
        <>
          <Row className="justify-content-center">
            <Col xs={6} lg={5} xl={4} className="imperial-ft">
              <Input
                name="heightFt"
                placeholder="0"
                label=""
                unit="ft"
                invalid={!!(touched.heightValue && errors.heightValue)}
                onBlur={() => setFieldTouched('heightValue')}
                text={undefined}
                step="1"
              />
            </Col>
            <Col xs={6} lg={5} xl={4} className="imperial-in">
              <Input
                name="heightIn"
                placeholder="0"
                label=""
                unit="in"
                min={0}
                max={11}
                invalid={!!(touched.heightValue && errors.heightValue)}
                onBlur={() => setFieldTouched('heightValue')}
                text={undefined}
                step="1"
              />
            </Col>
          </Row>

          {!!(touched.heightValue && errors.heightValue) && (
            <FormFeedback className="d-block">
              {t('biometric.height.validation', { min: '3 ft 4 in', max: '8 ft 2 in' })}
            </FormFeedback>
          )}
          {values.heightValue === 0 && (!errors.heightValue || !touched.heightValue) && (
            <FormText className="w-100">
              {t('biometric.height.description', { min: '3 ft 4 in', max: '8 ft 2 in' })}
            </FormText>
          )}
        </>
      )}
    </>
  );
};

export default Height;
